module.exports = __webpack_public_path__ + "static/media/socialInstagram.7c67a418.svg";